<template>
  <div>
    <a-card class="customer-filter">
      <a-form-model :form="filterForm" :label-col="{ span: 6 }" :model="filterForm" class="search-form">
        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-model-item label="项目名称">
              <a-input v-model="filterForm.name" placeholder="项目名称" class="form-model-item" @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="状态">
              <a-select v-model="filterForm.status" placeholder="状态" allow-clear @change="onSearch">
                <a-select-option :value="0">启用</a-select-option>
                <a-select-option :value="1">已归档</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6">
            <a-form-model-item label="负责人">
              <user-select v-model="filterForm.owner" placeholder="负责人" show-search allow-clear @change="onSearch" />
            </a-form-model-item>
          </a-col>
          <a-col :span="6" style="float: right; text-align: right">
            <a-button type="primary" @click="onSearch">查询</a-button>
            <a-button :style="{ margin: '0 8px' }" @click="reset">重置</a-button>
          </a-col>
        </a-row>
      </a-form-model>
    </a-card>
    <a-card title="项目列表" size="small" class="filter-data">
      <span slot="extra">
        <a-button v-has="{ code: 'system:project:add', project: 0 }" class="handle-menu" type="primary" icon="plus" @click="onAdd">添加</a-button>
      </span>
      <a-table :loading="loading" :pagination="pagination" :columns="columns" size="middle" :data-source="tableData" row-key="id" @change="handleTableChange">
        <span slot="action" slot-scope="text, record">
          <a v-dis="{ code: 'system:project:edit', project: 0 }" @click="onEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a v-dis="{ code: 'system:project:delete', project: 0 }" @click="onDelete(record.id)">删除</a>
        </span>
        <span slot="status" slot-scope="text, record">
          <a-badge :status="record.status === 0 ? 'success' : 'warning'" :text="record.status === 0 ? '启用' : '已归档'" />
        </span>
        <span slot="logo" slot-scope="text, record">
          <a-avatar shape="square" icon="project" :src="record.logo" class="table-image" />
        </span>
        <span slot="owner" slot-scope="text, record">{{ record.owner && record.owner.nick_name ? record.owner.nick_name : '--' }}</span>
        <span slot="category" slot-scope="text, record">{{ record.category && record.category.label }}</span>
        <span slot="level" slot-scope="text, record">{{ record.level && record.level.label }}</span>
      </a-table>
    </a-card>
    <project-modal ref="projectModalRef" @ok="getProjectList" />
  </div>
</template>

<script>
import { projectList, projectDelete } from '@/api/project/project';

import UserSelect from '@/components/User/UserSelect';
import ProjectModal from '@/pages/system/components/ProjectModal';

const columns = [
  {
    title: 'Logo',
    dataIndex: 'logo',
    key: 'logo',
    width: 100,
    align: 'center',
    scopedSlots: { customRender: 'logo' }
  },
  {
    title: '项目名称',
    dataIndex: 'name',
    width: '15%',
    key: 'name'
  },
  {
    title: '项目描述',
    key: 'description',
    width: '35%',
    dataIndex: 'description'
  },
  {
    title: '负责人',
    key: 'owner',
    dataIndex: 'owner',
    width: '8%',
    scopedSlots: { customRender: 'owner' }
  },
  {
    title: '状态',
    key: 'status',
    dataIndex: 'status',
    align: 'center',
    width: '8%',
    scopedSlots: { customRender: 'status' }
  },
  {
    title: '创建时间',
    key: 'created_time',
    dataIndex: 'created_time',
    width: 180,
    align: 'center'
  },
  {
    title: '操作',
    width: 120,
    align: 'center',
    scopedSlots: { customRender: 'action' }
  }
];

export default {
  components: {
    ProjectModal,
    UserSelect
  },
  data() {
    return {
      columns,
      filterForm: {
        name: null,
        owner: null,
        category: null,
        level: null
      },
      pagination: {
        size: 'large',
        total: 0,
        pageSize: this.$store.getters.pageSize, // 每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100'], // 每页中显示的数据
        showTotal: total => `共 ${total} 条` // 分页中显示总的数据
      },
      tableData: [],
      loading: false
    };
  },
  mounted() {
    this.getProjectList();
  },

  methods: {
    // 点击添加
    onAdd() {
      this.$nextTick(() => {
        this.$refs.projectModalRef.open();
      });
    },

    // 点击编辑
    onEdit(project) {
      this.$nextTick(() => {
        this.$refs.projectModalRef.open(project.id);
      });
    },

    // 删除项目
    onDelete(id) {
      const self = this;
      this.$confirm({
        title: '确认',
        content: '确认要删除该项目吗',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk() {
          projectDelete({ project_id: id }).then(() => {
            self.$message.success('删除成功');
            self.getProjectList();
          });
        }
      });
    },

    // 获取项目列表
    getProjectList() {
      this.loading = true;
      const params = {
        ...this.filterForm,
        page_size: this.pagination.pageSize,
        page_number: this.pagination.current
      };
      if (params.status === null || params.status === undefined) delete params.status;
      if (!params.owner) delete params.owner;
      projectList(params)
        .then(res => {
          this.tableData = res.data.projects;
          this.pagination.total = res.data.total;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    reset() {
      this.filterForm = {
        name: null,
        owner: null,
        category: null,
        level: null
      };
      this.pagination.current = 1;
      this.pagination.pageSize = this.$store.getters.pageSize;
      this.getProjectList();
    },

    onSearch() {
      this.filterForm.page_number = 1;
      this.getProjectList();
    },

    handleTableChange(pagination) {
      this.pagination = pagination;
      this.filterForm.page_size = pagination.pageSize;
      this.filterForm.page_number = pagination.current;
      this.getProjectList();
    }
  }
};
</script>

<style lang="less">
.customer-filter {
  margin-bottom: 16px;
}

.handle-menu {
  margin: 0 5px;
}
.search-form .ant-form-item {
  display: flex;
}

.search-form .ant-form-item-control-wrapper {
  flex: 1;
}
</style>
<style lang="less" scoped>
.ant-form-item {
  margin-bottom: 0;
}
</style>
